export class FeatureFlags {
  public static readonly PARAMETRAGE = 'Parametrage';
  public static readonly VERSION = 'Version';
  public static readonly REDDITION_FORMULE = 'Reddition-Formule';
  public static readonly GESTION_MANUELLE = 'GestionManuelle';
}
